import { FC } from 'react';
import cn from 'classnames';
import Styles from './index.module.scss';

export interface ITips {
  className?: string;
  /** tips 内容 */
  tips: string | React.ReactNode;
  /** 点击关闭回调 */
  onClose?: () => void;
  /** 箭头的位置，左边、右边、中间 */
  arrowPosition?: 'left' | 'right' | 'center';
  /** 箭头方向，上、下、左、 右 */
  direction?: 'top' | 'bottom' | 'left' | 'right';
}

const Tips: FC<ITips> = ({
  className = '',
  tips,
  onClose,
  arrowPosition = 'center',
  direction = 'bottom',
}) => {
  const onClickClose = () => {
    onClose?.();
  }

  return (
    <div className={cn(Styles.root, Styles[`dir-${direction}`], className)}>
      <div className={Styles.tips}>{ tips }</div>
      <div className={cn(Styles.arrow, Styles[arrowPosition], Styles[`dir-${direction}`])} />
      <div className={Styles.close} onClick={onClickClose} />
    </div>
  );
};

export default Tips;
